import {useAuth0} from "@auth0/auth0-react";
import {Box, Button, Card, CardActions, CardContent, Grid, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import React from "react";
import PreviewOnly from "../utils/PreviewOnly";

const Landing = () => {
    const {user, isAuthenticated, isLoading} = useAuth0();

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    if (!isAuthenticated) {
        return null;
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={4}
            px={2}
            width="100%"
            boxSizing="border-box" // Ensure padding is included in the width calculation
        >
            <Typography variant="subtitle1">
                Hallo {user?.nickname}, lass uns backen!
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Card sx={{width: '100%', mb: 2}}>
                        <CardContent>
                            <Typography variant="h6">Pizzarechner</Typography>
                        </CardContent>
                        <CardActions>
                            <Link to={'/dough'}>
                                <Button variant="text" color="primary">Teig rechnen</Button>
                            </Link>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Box display="flex" flexDirection="row" gap={2}>
                        <Card sx={{width: '100%', mb: 2}}>
                            <CardContent>
                                <Typography variant="h6">Neapolitanische Pizza</Typography>
                            </CardContent>
                            <CardActions>
                                Under construction
                            </CardActions>
                        </Card>
                        <Card sx={{width: '100%', mb: 2}}>
                            <CardContent>
                                <Typography variant="h6">Römische Pizza</Typography>
                            </CardContent>
                            <CardActions>
                                Under construction
                            </CardActions>
                        </Card>
                    </Box>
                </Grid>
            </Grid>
            <Card sx={{width: '100%', mb: 2}}>
                <CardContent>
                    <Typography variant="h5">Schritt für Schritt</Typography>
                </CardContent>
                <CardActions>
                    Under construction
                </CardActions>
            </Card>
            <PreviewOnly>
                <Card sx={{width: '100%', mb: 2}}>
                    <CardContent>
                        <Typography variant="h5">Für Anfänger</Typography>
                    </CardContent>
                    <CardActions>
                        Under construction
                    </CardActions>
                </Card>
            </PreviewOnly>
        </Box>

    );
};

export default Landing;